import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'rms-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    standalone: false
})
export class ConfirmationModalComponent implements OnInit {

  @Input() body: string;
  @Input() headerText = 'Confirm';
  @Input() cancelText = 'GENERICS.CANCEL';
  @Input() confirmText = 'Confirm';
  @Input() confirmButtonClass = 'btn-primary';

  @ViewChild('confirmationModal', { static: true }) modal: ElementRef;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  public openModal() {
    return this.modalService.open(this.modal, { size: 'sm', centered: true, backdrop: 'static', keyboard: false });
  }

}
